<template>
  <div class="d-flex align-end py-3">
    <div>
      <div class="display-1">
        <v-icon
          size="30"
          v-if="icon && icon.length > 0"
        >
          {{ headerIcon }}
        </v-icon> 
        <span 
          v-if="title && title.length > 0" 
          class="ml-1"
        >{{ title }}</span>
      </div>
      <v-breadcrumbs
        :items="breadcrumbs"
        class="pa-0 py-1"
      />
    </div>
    <v-spacer />
    <slot />
    <v-btn
      v-if="isNewAllowed"
      text
      color="primary"
      @click="create()"
    >
      <v-icon>mdi-plus</v-icon> {{ (btnText && btnText.length > 0)? btnText : $t('sharedCommon.new') }}
    </v-btn>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class COAHeader extends Vue {

  @Prop() hideNew: boolean;
  @Prop() btnText:string;
  @Prop() icon?: string | null;
  @Prop() title?: string | "";
  @Prop() breadcrumbs?: Array<object> | [{
        text: "Master Data",
        disabled: false,
        exact: true,
        to: "/master-data",
      },
      {
        text: "Back Office",
        disabled: false,
        exact: true,
        to: "/master-data/back-office",
      },];
  
  public create() {
    this.$emit("create");
  }
  get isNewAllowed(){
    return !this.hideNew;
  }

  get headerIcon(){
    if(this.icon!=null && this.icon.length>0){
      return this.icon;
    }

    return "mdi-account-multiple-outline";
  }
}
</script>
